<template>
    <v-modal ref="modal" @opened="modalOpened" :disabled="disabled" :state="keepModalOpen" customButtonClass="c-dialog__button_send-reminders">
        <slot slot="title">{{ $t('preorder.send_reminders') }}</slot>
        <slot slot="buttonContent">
            <div class="c-button c-button--fullwidth c-button--outline">{{ $t('preorder.send_reminders') }}</div>
        </slot>
        <div class="c-targets o-gutter">
            <div>
                <v-add-user @userAdded="addNewUser" 
                    :customerKey="this.PreOrder.CustomerKey"
                    :roleOptions="[
                        { value: 'Klant', content: $t('users.roles.administrator')},
                        { value: 'MarketingKlant', content: 'Marketing'},
                        { value: 'PersoneelKlant', content: $t('users.roles.personnel')}
                    ]">
                </v-add-user>
            </div>
            <div class="c-table-wrapper">
                <table-component class="o-page-row" table-class="c-table c-table--small" :data="CustomerUsersOptions" :show-caption="false" :show-filter="false">

                    <table-column key="FirstName" :label="$t('users.first_name')" :sortable="false">
                        <template slot-scope="row">
                            {{row["FirstName"]}}
                        </template>
                    </table-column>
                    <table-column key="LastName" :label="$t('users.last_name')" :sortable="false">
                        <template slot-scope="row">
                            {{row["LastName"]}}
                        </template>
                    </table-column>
                    <table-column key="Email" :label="$t('users.email')" :sortable="false">
                        <template slot-scope="row">
                            {{row["Email"]}}
                        </template>
                    </table-column>
                    <table-column key="SendReminder" :label="$t('preorder.send_reminder')" :sortable="false">
                        <template slot-scope="row">
                            <v-switch @input="updateUser(row, $event)" name="stock_allowed" :value="false">
                            </v-switch>
                        </template>
                    </table-column>
                </table-component>
            </div>
            <div>
                <button :disabled="disabled" type="button" class="c-button c-button--alpha" @click="sendReminders">{{ $t('preorder.send_reminders') }}</button>
            </div>
        </div>
    </v-modal>
</template>

<script>
    import VModal from '@/components/modal/Modal'
    import VBlock from '@/components/blocks/Block'
    import VSwitch from '@/components/form/Switch'
    import VAddUser from '@/components/form/userSelect/AddUser'

    // Store
    import {mapGetters} from 'vuex'

    export default {
        components: {
            VModal,
            VBlock,
            VSwitch,
            VAddUser
        },
        props: {
            disabled: {type: Boolean, default: false}
        },
        data() {
            return {
                keepModalOpen: false
            }
        },
        computed: {
            ...mapGetters({
                PreOrder: 'PreOrder',
                CustomerUsersOptions: 'CustomerUsersOptions'
            })
        },
        methods: {
            modalOpened(){
                //load data in CustomersUsersOptions
                this.$store.dispatch('getCustomerUsersOptions', this.PreOrder.CustomerKey).then(() => {
                    this.CustomerUsersOptions.forEach(user => {
                        user.IsSelected = false
                    });
                });                 
            },
            addNewUser(newUser) {
                newUser.IsSelected = true;
                this.CustomerUsersOptions.push(newUser); //add new user to options
            },
            updateUser(row, isSelected){
                row.IsSelected = isSelected;
            },
            sendReminders(){
                let selectedUsers =  this.CustomerUsersOptions.filter(user => { return user.IsSelected });
                let emails = selectedUsers.map(a => a.Email);

                this.$store.dispatch('sendRemindersPreOrderById', {
                    preOrderId: this.PreOrder.Id,
                    body: {
                        Id: this.PreOrder.Id,
                        Users: emails
                    }
                }).then(() => {
                    this.$notify({
                        group: 'global',
                        title: this.$t('global.reminders_sent', { 'preorder': this.PreOrder.Brand + ' - ' + this.PreOrder.Collection}),
                        type: 'success',
                        duration: 2000
                    });

                    // Close dialog
                    this.$refs.modal.closeDialog();
                });
            }
        }
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/private";

</style>



// WEBPACK FOOTER //
// src/components/modal/salesman/SendReminders.vue